import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { NumberPadComponent } from '../../../common/number-pad/number-pad.component';

@Component({
  selector: 'monorepo-bulk-count-pad',
  templateUrl: './bulk-count-pad.component.html',
  styleUrls: ['./bulk-count-pad.component.scss'],
})
export class BulkCountPadComponent implements OnInit {
  @Input() enableBulkChange = true;
  @Input() count = 1;
  @Output() bulkCount = new EventEmitter<number>();

  @Input() bulkCountStream = [1, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50];
  activeStreamIndex: number = 0;
  rightArrowIcon = '/assets/right-arrow.svg';
  leftArrowIcon = '/assets/left-arrow.svg';
  addIcon = '/assets/add-icon.svg';
  subtractIcon = '/assets/subtract-icon.svg';
  numPadIcon = '/assets/md-point/num-pad-icon.svg';

  constructor(private modalController: ModalController) {}

  ngOnInit(): void {}

  increment() {
    if (this.enableBulkChange) {
      this.count += 1;
      this.bulkCount.emit(this.count);
    }
  }

  decrement() {
    if (this.enableBulkChange && this.count > 1) {
      this.count -= 1;
      this.bulkCount.emit(this.count);
    }
  }

  async openNumberPad() {
    if (this.enableBulkChange) {
      const popup = await this.modalController.create({
        component: NumberPadComponent,
        componentProps: {
          heading: 'input_app_common.count',
          count: 0,
          enableDecimal: false,
          enablePrevButton: false,
          enableNextButton: false,
          enableCancel: true,
          enableSave: true,
        },
        cssClass: 'm-bulk-count-number-pad',
      });
      popup.present();
      popup.onDidDismiss().then((res) => {
        if (res.data) {
          console.log('NUMBER PAD VALUE', res.data);
          this.count = res.data;
          this.bulkCount.emit(this.count);
        }
      });
    }
  }

  #onActiveStreamIndexUpdate() {
    this.count = this.bulkCountStream[this.activeStreamIndex];
    this.bulkCount.emit(this.count);
  }

  updateActiveStreamIndex(index: number) {
    this.activeStreamIndex = index;
    this.#onActiveStreamIndexUpdate();
  }

  incrementActiveStreamIndex() {
    this.activeStreamIndex = (this.activeStreamIndex + 1) % this.bulkCountStream.length;
    this.#onActiveStreamIndexUpdate();
  }

  decrementActiveStreamIndex() {
    this.activeStreamIndex = this.activeStreamIndex > 0 ? this.activeStreamIndex - 1 : 0;
    this.#onActiveStreamIndexUpdate();
  }
}
